export default function About() {
  return (
    <div id="about" className="govuk-width-container govuk-!-padding-top-8 govuk-!-padding-bottom-8">
      <div className="govuk-grid-row">
        <div className="govuk-grid-column-full">
          <h2 className="govuk-heading-l govuk-!-margin-bottom-6">About me</h2>
        </div>
      </div>
      <div className="govuk-grid-row">
        <div className="govuk-grid-column-two-thirds">
          <p className="govuk-body">
            I'm Harsh Bhaveshkumar Trivedi, a Computer Science graduate at De Montfort
            University, Leicester, with a track record of delivering digital transformation
            projects inside local government. I specialise in taking public-facing services
            from legacy, manual processes to secure, accessible, GDS-aligned digital platforms.
          </p>
          <p className="govuk-body">
            As a Placement Technical Specialist at Leicestershire County Council, I built
            Drupal platforms to WCAG 2.1 AA standards, developed an AI-powered chatbot for
            the council's public-facing website, contributed to a 50% statutory SLA
            improvement on the SENA programme, and worked extensively with Power BI,
            Microsoft 365 and Azure across Housing, Adult Social Care and Children's
            Services.
          </p>
          <p className="govuk-body">
            I combine hands-on engineering with PRINCE2-aligned project and change
            management - I've since gone on to lead a 7-person development team,
            manage supplier relationships, and take full ownership of GDPR-compliant,
            production digital services from requirements through to go-live.
          </p>
        </div>

        <div className="govuk-grid-column-one-third">
          <dl className="govuk-summary-list">
            <div className="govuk-summary-list__row">
              <dt className="govuk-summary-list__key">Based in</dt>
              <dd className="govuk-summary-list__value">Coventry, England</dd>
            </div>
            <div className="govuk-summary-list__row">
              <dt className="govuk-summary-list__key">Experience</dt>
              <dd className="govuk-summary-list__value">3 years - public sector tech &amp; digital transformation</dd>
            </div>
            <div className="govuk-summary-list__row">
              <dt className="govuk-summary-list__key">Accessibility</dt>
              <dd className="govuk-summary-list__value">WCAG 2.1 AA delivered</dd>
            </div>
            <div className="govuk-summary-list__row">
              <dt className="govuk-summary-list__key">Delivery standard</dt>
              <dd className="govuk-summary-list__value">GDS-aligned</dd>
            </div>
            <div className="govuk-summary-list__row">
              <dt className="govuk-summary-list__key">Degree</dt>
              <dd className="govuk-summary-list__value">
                BSc Computer Science, De Montfort University (predicted First)
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}
